export default __webpack_public_path__ + "media/icons/icon-color-monitor-73d27293.png";